module.exports = __webpack_public_path__ + "img/map-dubai.18199776.png";